import config from '../config/index';

function getDownloadStripeReceiptUrl({ contactId, paymentIntentId, orgId }) {
  return `${config.apiUrl}/creditor/${orgId}/debtor/${contactId}/receipt/${paymentIntentId}`;
}

export default getDownloadStripeReceiptUrl;
